import { isEmpty, isNil, filter } from 'lodash';
import { convertValuByUnit } from '@/utils/number';

/**
 * 범례 보이기/숨김 처리를 한다.
 * 최대 10개의 항목만 활성화 할 수 있다.
 * @param  {[type]} vueCmp        [필수] 호출한 vue 컴포넌트
 * @param  {[type]} currentSeries [필수] 현재 series
 * @return {[type]}        [description]
 * @author jda
 */
function clickLegend(vueCmp, currentSeries) {
  const visibleSeries = filter(currentSeries.chart.series, 'visible');

  if (currentSeries.visible) {
    vueCmp.legendClass = 'legend-off';
    currentSeries.setVisible(false, false);
  } else if (!currentSeries.visible && visibleSeries.length < 10) {
    vueCmp.legendClass = null;
    currentSeries.setVisible(true, false);
  }
}

/**
 * 범례 활성화/비활성화의 className을 반환한다.
 * @param  {[type]} currentSeries [필수] 현재 series
 * @return {[type]}               [description]
 * @author jda
 */
function getLegendClass(currentSeries) {
  if (isEmpty(currentSeries)) {
    return null;
  }
  return currentSeries.visible ? null : 'legend-off';
}

/**
 * 범례에 표현할 이름을 반환한다.
 * @param  {[type]} series [description]
 * @return {[type]}        [description]
 * @author jda
 */
function convertLegendName(series) {
  if (isEmpty(series)) {
    return null;
  }

  const rscInfo = series.options.rscInfo;
  if (!isEmpty(rscInfo)) {
    // SKT 인프라 요청사항에 의해 에러율과 기각률에 영여표기 진행
    const rscId = rscInfo.rscId;
    if (rscId.indexOf('TRAFFIC_ERROR') > -1) {
      return rscId === 'TRAFFIC_ERROR_IN' ? `에러율[Error] (IN) ${rscInfo.rscKeyName}` : `에러율[Error] (OUT) ${rscInfo.rscKeyName}`;
    } else if (rscId.indexOf('TRAFFIC_DISCARD') > -1) {
      return rscId === 'TRAFFIC_DISCARD_IN' ? `기각률[Discard] (IN) ${rscInfo.rscKeyName}` : `기각률[Discard] (OUT) ${rscInfo.rscKeyName}`;
    }
    return isEmpty(rscInfo.rscKey) ? `${rscInfo.rscName}` : `${rscInfo.rscName} ${rscInfo.rscKeyName}`;
  }
  return series.name;
}

/**
 * 범례의 장비명을 표현한다.
 * @param  {[type]} series [description]
 * @return {[type]}        [description]
 * @author jda
 */
function convertLegendObjName(series) {
  if (isEmpty(series)) {
    return null;
  }

  const rscInfo = series.userOptions.rscInfo;
  return isEmpty(rscInfo) ? null : rscInfo.objName;
}

/**
 * 차트의 데이터를 단위변환 한다.
 * @param  {[type]} point [description]
 * @return {[type]}       [description]
 * @author jda
 */
function convertChartValuByUnit(point) {
  let unit = null;
  if (point.series) {
    const rscInfo = point.series.userOptions.rscInfo;
    if (!isNil(rscInfo)) {
      unit = rscInfo.rscUnit;
    }
  }
  return convertValuByUnit(point.y, unit, true, false);
}

/**
 * 유닛이 %인 차트의 yAxis max와 min을 설정
 * @param  {[type]} chartOption [description]
 * @return {[type]}             [description]
 * @author najong
 */
function setYAxisRange(chartOption) {
  const series = chartOption.series;
  if (!isEmpty(series) && !isNil(series[0].rscInfo)) {
    const rscUnit = series[0].rscInfo.rscUnit;
    if (!isNil(rscUnit) && rscUnit === '%') {
      chartOption.yAxis.min = 0;
      chartOption.yAxis.max = 100;
    } else {
      delete chartOption.yAxis.min;
      delete chartOption.yAxis.max;
    }
  }
}

export default {
  clickLegend,
  getLegendClass,
  convertLegendName,
  convertLegendObjName,
  convertChartValuByUnit,
  setYAxisRange,
};



// WEBPACK FOOTER //
// ./src/utils/charts.js